
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { finalize } from 'rxjs';
import { ApiService } from 'src/app/services/api/api.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { SuccessModalComponent } from 'src/app/shared/modals/success-modal/success-modal.component';
import { ConfirmActionComponent } from 'src/app/shared/components/confirm-action/confirm-action.component';
import { ErrorModalComponent } from 'src/app/shared/modals/error-modal/error-modal.component';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';
import { PaymentModalComponent } from 'src/app/shared/modals/payment-modal/payment-modal.component';
import { StreetNamingDetailsModalComponent } from '../../street-naming/street-naming-details-modal/street-naming-details-modal.component';
import { environment } from 'src/environments/environment';
import { BirthRegistrationDetailsModalComponent } from '../birth-registration-details-modal/birth-registration-details-modal.component';

enum View {
  MY_ASSESSMENTS = 'MY_ASSESSMENTS',
  ALL_ASSESSMENTS = 'ALL_ASSESSMENTS',
  PENDING_ASSESSMENTS = 'PENDING_ASSESSMENTS',
  ALL = 'ALL'
}

@Component({
  selector: 'app-birth-registration-landing',
  standalone: false,
  templateUrl: './birth-registration-landing.component.html',
  styleUrl: './birth-registration-landing.component.scss'
})
export class BirthRegistrationLandingComponent {
  action_idx: any = null;

  dataList: any[] = [];
  form: FormGroup;

  isSearching: boolean = false;
  showSearchForm: boolean = false;

  searchedDataNotFound = false;
  isEmpty!: boolean;
  searched = false;
  isLoading: boolean = false;

  selectedStatus!: boolean;

  isDarkMode!: boolean;
  downloadId: any;

  page: number = 0;
  num: number = 1;
  currentPage: number = 1;
  count: number = 0;
  pageSize: number = 10;
  selectedLimit: number = 10;



  View = View;
  activeTab: View;

  role: string;
  showTabs: boolean = true;
  @Output() onConfirmClicked = new EventEmitter();
  downloadingCertificate: boolean;

  toggleShowSearch() {
    this.showSearchForm = !this.showSearchForm;
  }

  constructor(
    public fb: FormBuilder,
    private apiService: ApiService,
    private authService: AuthService,
    public dialog: MatDialog,
    private router: Router,
    private route: ActivatedRoute,

  ) { }

  ngOnInit(): void {
    this.role = this.authService.getRole();

    this.showTabs = this.hasAccess(['CAN_APPROVE_BIRTH_REGISTRATION', 'CAN_CREATE_BIRTH_REGISTRATION']);

    if (this.showTabs) {
      if (this.hasAccess(['CAN_APPROVE_BIRTH_REGISTRATION'])) {
        this.activeTab = View.PENDING_ASSESSMENTS;
      }

      if (this.hasAccess(['CAN_CREATE_BIRTH_REGISTRATION'])) {
        this.activeTab = View.MY_ASSESSMENTS;

      }
    }


    this.form = this.fb.group({
      assessmentId: [''],
      approvalStatus: [''],
      paymentStatus: [''],
      from: [''],
      to: [''],
      offset: [''],
    });

    this.getFilteredApplications();
  }

  viewApplication(data: any) {
    let dialog = this.dialog.open(BirthRegistrationDetailsModalComponent, {
      width: '400px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'custom-dialog-lg', 'scrollable-modal'],
      disableClose: true,

      data,
    })
  }

  create() {
    this.router.navigate(['/admin/birth-registration/apply'])
  }

  hasAccess(permissions: string[]) {
    return this.authService.hasAnyPermission(permissions)
  }

  clearSearchFilters() {
    this.form.reset()
  }

  openSuccessModal(message: string) {
    let dialogRef = this.dialog.open(SuccessModalComponent, {
      width: '350px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      data: { successMessage: message },
    });

    dialogRef.afterClosed().subscribe(() => {
      location.reload();
    });
  }

  openErrorModal(message: string) {
    let dialogRef = this.dialog.open(ErrorModalComponent, {
      width: '350px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      data: { errorMessage: message },
    });

    dialogRef.afterClosed().subscribe(() => { });
  }



  downloadDemandNotice(assessmentId) {
    this.downloadId = assessmentId;
    let url = `/assessment/download/demand-notice?id=` + assessmentId;
    this.apiService
      .post(url, {}, { responseType: "blob" })
      .pipe(
        finalize(() => {
          this.downloadId = false;
        })
      )
      .subscribe(
        (response: Blob) => {
          const blob = new Blob([response], { type: "application/pdf" });
          const blobUrl = window.URL.createObjectURL(blob);
          const file = new Blob([response], { type: "application/pdf" });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
          const downloadLink = document.createElement("a");
          downloadLink.href = blobUrl;
          downloadLink.target = "_blank";
          downloadLink.download = "demand-notice.pdf";
          downloadLink.click();

        },
        (error) => {
          this.openErrorModal("Error downloading demand notice");
        }
      );
  }



  setIsActive(tab: any) {

    this.activeTab = tab;

    this.getFilteredApplications()

    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { tab },
      queryParamsHandling: 'merge',
    });
  }


  callDb(event: any) {
    this.currentPage = event;

    this.page = event - 1;

    this.getFilteredApplications();
  }

  updateLimit() {
    this.currentPage = 1;

    this.page = 0;

    this.getFilteredApplications();
  }

  errorFetchingData: boolean = false;



  getFilteredApplications() {
    this.dataList = [];
    this.searchedDataNotFound = false;
    this.isSearching = true;
    this.errorFetchingData = false;

    this.pageSize = this.selectedLimit;

    this.num = this.page * this.selectedLimit;

    const searchAndFilterValues = this.form?.value;

    var filterParams: any = new FormData();

    filterParams.append('offset', this.num);
    filterParams.append('limit', this.selectedLimit);
    filterParams.append("assessmentId", this.form.get('assessmentId')?.value || '');
    filterParams.append("approvalStatus", this.form.get('approvalStatus')?.value || '');
    filterParams.append("paymentStatus", this.form.get('paymentStatus')?.value || '');
    filterParams.append("from", this.form.get('from')?.value || '');
    filterParams.append("to", this.form.get('to')?.value || '');
    filterParams.append("workflowName", "BIRTH_REGISTRATION");

    const activeTab = this.activeTab;


    switch (activeTab) {
      case 'PENDING_ASSESSMENTS': {
        this.fetchPendingWorkflowLogs(filterParams, activeTab);
        break;
      }

      case 'ALL_ASSESSMENTS': {
        this.fetchAssessments(filterParams, activeTab);
        break
      }

      case 'MY_ASSESSMENTS': {
        // this.fetchPendingWorkflowLogs(filterParams, activeTab);
        this.fetchMyAssessments(filterParams, activeTab);
        break
      }


      default: {
        if (this.hasAccess(['CAN_CREATE_BIRTH_REGISTRATION'])) {
          this.fetchMyAssessments(filterParams, activeTab);
          // this.fetchAssessments(filterParams, activeTab);

          return
        }

        this.fetchAssessments(filterParams, activeTab);
        return;
      }
    }
  }


  fetchPendingWorkflowLogs(filterParams: FormData, activeTab: string) {
    this.apiService
      .post('/workflow/pending/logs/page', filterParams)
      .pipe(
        finalize(() => {
          this.isSearching = false;
          this.isLoading = false;
        })
      )
      .subscribe(
        (response) => {
          this.dataList = response.data.map(item => ({ ...item, entity: { ...item.entity, id: item?.entity?.entityId, createdAt: item?.entity.assessmentDate, amount: item?.entity?.grossIncome } }));

          this.count = response.totalElements;

          if (this.count == 0) {
            this.searchedDataNotFound = true;
          }
        },
        (error) => {
          this.openErrorModal(error?.message);
          this.errorFetchingData = true;
        }
      );
  }


  fetchMyAssessments(filterParams: FormData, activeTab: string) {
    this.apiService
      .post('/birth/my/page', filterParams)
      .pipe(
        finalize(() => {
          this.isSearching = false;
          this.isLoading = false;
        })
      )
      .subscribe(
        (response) => {

          this.dataList = response.data.map(item => ({ entity: item }));


          this.count = response.totalElements;

          if (this.count == 0) {
            this.searchedDataNotFound = true;
          }
        },
        (error) => {
          this.openErrorModal(error?.message);
          this.errorFetchingData = true;
        }
      );
  }

  fetchAssessments(filterParams: FormData, activeTab: string) {
    this.apiService
      .post('/birth/paged', filterParams)
      .pipe(
        finalize(() => {
          this.isSearching = false;
          this.isLoading = false;
        })
      )
      .subscribe(
        (response) => {


          this.dataList = response.data.map(item => ({ entity: item }));

          this.count = response.totalElements;

          if (this.count == 0) {
            this.searchedDataNotFound = true;
          }
        },
        (error) => {
          this.openErrorModal(error?.message);
          this.errorFetchingData = true;
        }
      );
  }



  startInterswitch(assessment: any) {
    const assessmentEntity = assessment.entity

    const father = assessmentEntity.parents.find(p => p.parentType === "Father");

    const url = '/payment/initialize';
    const details = {
      paymentAmount: assessmentEntity?.amount,
      callbackUrl: environment.envUrl + 'admin/birth-registration',
      email: '',
      phoneNumer: father?.phoneNumber,
      asin: father?.phoneNumber,
      revenueName: "COURT WEDDING/ CERTIFICATE",
      entityId: assessmentEntity?.id,
      entityType: "BIRTH_REGISTRATION"
    };
    this.apiService.post(url, details).subscribe({
      next: (response) => {
        this.checkout(response.data);
      },
      error: (error) => {
        console.info(`Unable to reach Interswitch: ${error}`);
      },
    });
  }

  checkout(details: any) {
    var paymentRequest = {
      merchant_code: details?.merchantCode,
      pay_item_id: details?.payItemId,
      txn_ref: details?.orderId,
      cust_id: details?.customerId,
      amount: Math.round((details?.amount * 100 + Number.EPSILON) * 100) / 100,
      currency: '566',
      site_redirect_url: window.location.origin,
      onComplete: (response: any) => this.paymentCallback(response),
      mode: details?.mode,
    };

    if (
      details?.mode === 'LIVE' &&
      details?.splitAccounts &&
      Object.keys(details?.splitAccounts).length > 0
    ) {
      paymentRequest['split_accounts'] = JSON.stringify(details?.splitAccounts);
    }

    (window as any).webpayCheckout(paymentRequest);
  }

  openPaymentSuccessModal(message: string) {
    let dialogRef = this.dialog.open(SuccessModalComponent, {
      width: '350px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      data: { successMessage: message },
    });

    dialogRef.afterClosed().subscribe(() => {
      this.getFilteredApplications()
    });
  }

  paymentCallback(response: any) {

    const url = '/payment/acknowledge?orderId=' + response?.txnref;
    this.apiService.post(url, {}).subscribe(
      (response) => {

        if(response.status == 'OK'){

          this.openPaymentSuccessModal("Payment made successfully")

        }

      },
      (error) => {
        console.info(`Unable to reach Interswitch: ${error}`);
      }
    );
    return;
  }

  downloadCertificate(item: any){

    this.downloadingCertificate = true

    let url = "/birth/download/birth/certificate";

    this.apiService.post(url, item, { responseType: 'blob' }).subscribe(
        (response: Blob) => {

          const blob = new Blob([response], { type: 'application/pdf' });

          const blobUrl = window.URL.createObjectURL(blob);

          const file = new Blob([response], { type: 'application/pdf' });

          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);


          const downloadLink = document.createElement('a');
          downloadLink.href = blobUrl;
          downloadLink.target = '_blank';
          downloadLink.download = 'birth_certificate.pdf';

          downloadLink.click();

          this.downloadingCertificate = false
        },
        (error) => {
          this.downloadingCertificate = false
          this.openErrorModal(error?.message);
        }
    );

  }


}
